export const decryptText = async (encryptedText: string, signature: string) => {
  if (!encryptedText || !signature) return encryptedText;

  const signatureBuffer = new TextEncoder().encode(signature);
  const keyBuffer = await crypto.subtle.digest('SHA-256', signatureBuffer);
  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    keyBuffer,
    { name: 'AES-GCM' },
    false,
    ['decrypt'],
  );

  const combined = atob(encryptedText);
  const [ivHex, tagHex, cipherHex] = combined.split(':');
  if (!cipherHex) throw new Error('Invalid encrypted format');

  const hexToBytes = (hex: string) => {
    const len = hex.length / 2;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {

      bytes[i] = parseInt(hex.substr(i * 2, 2), 16);
    }
    return bytes;
  };

  const iv = hexToBytes(ivHex); // Uint8Array
  const tag = hexToBytes(tagHex); // Uint8Array
  const ciphertext = hexToBytes(cipherHex); // Uint8Array

  const data = new Uint8Array(ciphertext.length + tag.length);
  data.set(ciphertext, 0);
  data.set(tag, ciphertext.length);

  const plainBuffer = await crypto.subtle.decrypt(
    {
      name: 'AES-GCM',
      iv, // бажано 12 байтів
      tagLength: 128, // біт
    },
    cryptoKey,
    data,
  );

  return new TextDecoder().decode(plainBuffer);
};
